import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { MainComponent } from './main.component';
import { ExternalApplicationsFormComponent } from './components/external-applications/external-applications-form/external-applications-form.component';
import { ApplicationSettingsComponent } from "./components/application-settings/application-settings.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { UserSettingsComponent } from "./components/user-settings/user-settings.component";

const routes: Routes = [
  {path: 'not-found', component: NotFoundComponent},
  {path: '', component: MainComponent,  children: [
      {path: '', component: LandingComponent},
      {path: 'billing', component: LandingComponent},
      {path: 'settings', component: UserSettingsComponent},
      {path: 'settings/:appCode', component: ApplicationSettingsComponent},
      {path: 'external-applications', children: [
          {path: 'new', component: ExternalApplicationsFormComponent},
          {path: ':uuid/edit', component: ExternalApplicationsFormComponent}
        ]
      },
    ]
  },
  {path: '**', redirectTo: '/not-found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
